module.exports = __webpack_public_path__ + "img/astronaut1.d594c762.jpg";